module.exports = __webpack_public_path__ + "img/ident_icon.60cd7086.png";